var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBuildIconInternet = function SvgBuildIconInternet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#988642",
    d: "M25.353 31.057a2.996 2.996 0 0 1-4.232-.01 2.996 2.996 0 0 1-.01-4.232 2.996 2.996 0 0 1 4.23.01 2.996 2.996 0 0 1 .012 4.232m-3.478-3.477a1.915 1.915 0 0 0 .008 2.705c.747.747 1.96.75 2.705.007a1.915 1.915 0 0 0-.008-2.705 1.915 1.915 0 0 0-2.704-.007M33.698 23.323a.65.65 0 0 1-.918-.002c-5.363-5.364-14.067-5.387-19.403-.051a.65.65 0 0 1-.917-.003.65.65 0 0 1-.003-.917c5.84-5.84 15.368-5.814 21.238.056a.65.65 0 0 1 .003.917"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#988642",
    d: "M40.202 17.089a.65.65 0 0 1-.917-.003c-8.82-8.82-23.134-8.858-31.908-.084A.65.65 0 0 1 6.46 17a.65.65 0 0 1-.003-.917c9.279-9.279 24.416-9.239 33.743.088a.65.65 0 0 1 .002.918"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#988642",
    d: "M46.39 11.01a.65.65 0 0 1-.917-.003c-12.19-12.19-31.97-12.241-44.096-.116a.65.65 0 0 1-.917-.002.65.65 0 0 1-.003-.918c12.63-12.63 33.234-12.575 45.93.12a.65.65 0 0 1 .003.918"
  })));
};
export default SvgBuildIconInternet;